import React, {Component} from "react";
import styled from "@emotion/styled";
import {observer} from "mobx-react";

import {fn_setDeliveryFlag} from "function/FnBodySetting"
import trashIcon from "static-file/images/trash.svg";

import {showModal} from "utils/ShowModal";
import {ModalMessages} from "components/modal/constant/Modal";
import {comma} from "utils/Utils";
import {delivery_disconnect_request} from "http/DetailConn";
import {search_dlv_store_info} from "http/dlvCommonConn";
import {pay_free_yntype} from "../../../http/SettingConn";

const ListWrap = styled.div`
    display: flex;
    justify-content: space-between;
`
const TextWrap = styled.div`
    display: flex;
    gap: 12px;
`
const Text = styled.p`
    color: ${({color}) => color || "#555C62"};
    font-size: ${({size}) => size || "14px"};
    font-weight: ${({weight}) => weight || "400"};
    line-height: 150%;
`
const IconWrap = styled.div`
    width: 42px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid #B2B3B4;

    display: flex;
    align-items: center;
    justify-content: center;
`
const TrashIcon = styled.div`
    width: 24px;
    height: 24px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${trashIcon});
`;
const Spacer = styled.div`
    height: ${({height}) => height || "24px"};
    flex-shrink: 0;
`;

@observer
class SettingDefaultDeliveryItemView extends Component {
    render() {
        const {obj} = this.props;
        const {rootStore} = this.props;

        const handleIconClick = async () => {
            try {
                await showModal({
                    modalMsg: {
                        ...ModalMessages.CONFIRM_AGENCY_DELETE,
                        text: `${obj.delivery_name} 연동을 삭제하시겠습니까?`,
                    },
                });

                const response = await delivery_disconnect_request(rootStore, obj);

                if (response.data.resultCode !== "000") {
                    throw new Error(response.data.resultMsg);
                }

                await search_dlv_store_info(rootStore); // 배달 대행사 연동 목록 조회

                await pay_free_yntype(rootStore); // 유/무료 설정 조회

                await showModal({
                    modalMsg: ModalMessages.AGENCY_DELETE_SUCCESS,
                });

            } catch (error) {
                showModal({
                    modalMsg: ModalMessages.API_FAIL,
                });
            }
        };


        return (
            <>
                <li className="list">
                    <div className="tit">
                        <ListWrap>
                            <TextWrap>
                                <p className="platform">{obj.delivery_name}</p>
                                <p className="company">({obj.parent_delivery_name})</p>
                            </TextWrap>

                            <Text color='#555C62' size="19px" weight="700">예치금 {comma(obj.shop_cash)}원</Text>
                        </ListWrap>

                        <Spacer height="10px"/>
                        <div>
                            <IconWrap onClick={handleIconClick}>
                                <TrashIcon/>
                            </IconWrap>

                            <label className="lab_check s" htmlFor={obj.dumaspDeliveryCode}>
                                <input type="checkbox" name="dlvCheck" id={obj.dumaspDeliveryCode} className="inp"
                                       checked={obj.use_yn === "Y" ? true : false}
                                       onChange={() => fn_setDeliveryFlag(rootStore, obj.dumaspDeliveryCode, obj.use_yn)}
                                />
                                <span></span>
                            </label>
                        </div>
                    </div>
                </li>
            </>
        )
    }
}

export default SettingDefaultDeliveryItemView;